import React from "react";

import * as SC from "./../PrintMetricsValue.styled";
import { MetricTypes } from "../../../../PagesUser/Campaign/DataVisualization/enums/metrics";

function useWinnerDot() {
  const renderDot = (metric, metricValue, highestMetricValue) => {
    if (!metric || !metricValue) return;

    const isCTR = metric === MetricTypes.CTR;

    if ((isCTR && metricValue > 1) || (!isCTR && metricValue === highestMetricValue)) {
      return <SC.WinnerDot />;
    }

    return <SC.EmptyDot />;
  };

  return { renderDot };
}

export default useWinnerDot;
